// removed by extract-text-webpack-plugin
module.exports = {"default-department-wrapper":"index__default-department-wrapper___28IvT","default-department":"index__default-department___1QEcq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/DefaultDepartment/index.less
// module id = 1041
// module chunks = 3